/** Route paths are host-relative; each app uses its own domain in production. */
export const APP_TITLE = 'Genius Dashboard';
export const APP_ROOT_PATH = '/';
export const LOGIN_PATH = '/login';

export const SCHOOL_REPORT_PATH = '/:schoolId';

export function buildSchoolReportHref(schoolId: string): string {
  return `/school-report/${encodeURIComponent(schoolId.trim())}`;
}
